// ── PC 좌 패널 — 매장카드 (모바일 정산서 컴포넌트 직접 사용) ────────────────────
// settlementdot/StoreCard + settlementdot/PayComponents를 그대로 import
// → 정산서 UI 변경 시 이쪽도 자동 반영

import React, { useState } from 'react';
import { C } from './constants';
import { fmt } from './utils';
import { toDateString } from '../../../utils/date';
import { LEFT_PANEL, PANEL_TITLE, SCROLL, emptyTxt } from './pcStyles';
// 모바일 정산서 컴포넌트 직접 import (공유 단일 소스)
import { StoreCard } from '../../employee/settlementdot/StoreCard';
import { PayGroup }  from '../../employee/settlementdot/PayComponents';
import { ConsultantChargeDetailModal } from '../../../components/settlement/ConsultantChargeDetailModal';

export function PcLeftPanel({
  selectedUser,
  dataLoading,
  marketerData,
  unmTotal,
  leftItems,
  leftTab,
  setLeftTab,
  selectedPay,
  setSelectedPay,
  handlePaymentClick,
  handleStoreCardClick,
  handleUnlink,
  linking,
  expandedId,
  setExpandedId,
  onEditShareRate,  // 상담자 배분율 편집 — 관리자 전용
}) {
  const { unmatchedRevenue } = marketerData;
  const [chargeDetail, setChargeDetail] = useState(null);

  // ── 탭바 스타일 ───────────────────────────────────────────────────────────
  const tabBarSt = {
    display: 'flex', alignItems: 'center',
    background: 'var(--bg-card)',
    borderBottom: `1px solid ${C.border}`,
    padding: '0 8px',
    flexShrink: 0,
  };
  const tabSt = (active) => ({
    flex: 1, padding: '11px 0',
    background: 'none', border: 'none',
    fontSize: 13, fontWeight: 600,
    color: active ? C.accent : C.subDark,
    cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5,
    borderBottom: active ? `2.5px solid ${C.accent}` : '2.5px solid transparent',
    transition: 'color 0.15s, border-color 0.15s',
  });
  const badgeSt = (active, danger) => ({
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    minWidth: 17, height: 17,
    background: danger ? '#fee2e2' : active ? 'rgba(99,102,241,0.12)' : 'var(--bg-subtle)',
    color: danger ? '#dc2626' : active ? C.accent : C.subDark,
    borderRadius: 9, fontSize: 10, fontWeight: 700, padding: '0 4px',
  });

  // ── 선택 배너 ─────────────────────────────────────────────────────────────
  const selBanner = selectedPay && (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      background: 'rgba(99,102,241,0.07)',
      borderBottom: `2px solid ${C.accent}`,
      padding: '8px 12px', flexShrink: 0,
    }}>
      <span style={{ fontSize: 20, lineHeight: 1 }}>↕</span>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: C.accent }}>결제 항목 선택됨</span>
        <span style={{ fontSize: 11, color: C.subDark }}>연결할 매장 카드를 클릭하세요</span>
      </div>
      <button
        onClick={() => setSelectedPay(null)}
        style={{
          background: 'none', border: `1.5px solid ${C.accent}`,
          borderRadius: 6, padding: '4px 10px',
          fontSize: 11, fontWeight: 600, color: C.accent, cursor: 'pointer', flexShrink: 0,
        }}
      >취소</button>
    </div>
  );

  return (
    <div style={{ ...LEFT_PANEL, display: 'flex', flexDirection: 'column' }}>

      {/* 패널 타이틀 */}
      <div style={PANEL_TITLE}>
        매장카드
        {marketerData.clients.length > 0 && ` (${marketerData.clients.length})`}
      </div>

      {/* 내부 탭바 */}
      <div style={tabBarSt}>
        <button style={tabSt(leftTab === 'stores')} onClick={() => setLeftTab('stores')}>
          담당 매장
          {marketerData.clients.length > 0 && (
            <span style={badgeSt(leftTab === 'stores', false)}>{marketerData.clients.length}</span>
          )}
        </button>
        <button style={tabSt(leftTab === 'unmatched')} onClick={() => setLeftTab('unmatched')}>
          미연결 결제
          {unmTotal > 0 && (
            <span style={badgeSt(leftTab === 'unmatched', true)}>{unmTotal}</span>
          )}
        </button>
      </div>

      {/* 본문 */}
      {!selectedUser ? (
        <div style={emptyTxt}>마케터를 선택하세요</div>
      ) : dataLoading ? (
        <div style={emptyTxt}>불러오는 중...</div>
      ) : (
        <div style={SCROLL}>

          {/* ── 담당 매장 탭 ── */}
          {leftTab === 'stores' && (
            <>
              {selBanner}
              {leftItems.length === 0 && <div style={emptyTxt}>담당 매장 없음</div>}
              {leftItems.map((item) =>
                item.kind === 'client' ? (
                  // settlementdot/StoreCard 직접 사용 — UX 동일
                  <StoreCard
                    key={`client-${item.data.id}`}
                    client={item.data}
                    expanded={expandedId === item.data.id}
                    onToggle={() => setExpandedId((p) => p === item.data.id ? null : item.data.id)}
                    hasSelected={!!selectedPay}
                    onClick={() => handleStoreCardClick(item.data.id)}
                    isDragOver={false}
                    onDragOver={() => {}}
                    onDragLeave={() => {}}
                    onDrop={() => {}}
                    onUnlink={handleUnlink}
                    canEdit={true}
                    onEditShareRate={onEditShareRate}
                  />
                ) : item.kind === 'consultant_share_income' ? (
                  <div
                    key={`consultant-share-income-${item.data.contractId || item.data.clientId}`}
                    style={{
                      margin: '6px 4px',
                      borderRadius: 12,
                      background: 'rgba(37,99,235,0.06)',
                      border: '1px solid rgba(37,99,235,0.22)',
                      padding: '12px 16px',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, background: '#dbeafe', color: '#2563eb', padding: '2px 8px', borderRadius: 10, whiteSpace: 'nowrap' }}>상담자배분</span>
                        <span style={{ fontSize: 12, color: C.sub, whiteSpace: 'nowrap' }}>{item.date}</span>
                      </div>
                      <span style={{ fontSize: 15, fontWeight: 800, color: '#2563eb', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                        +{fmt(item.data.amount || 0)}원
                      </span>
                    </div>
                    <div style={{ marginTop: 6, fontSize: 12, color: C.subDark, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {item.data.clientName || '상담자배분 수입'}
                    </div>
                    <div style={{ marginTop: 4, fontSize: 11, color: C.sub }}>
                      {item.data.chargedMarketerName ? `${item.data.chargedMarketerName} 차감분` : ''}
                    </div>
                  </div>
                ) : item.kind === 'consultant_charge' ? (
                  <div
                    key={`consultant-charge-${item.data.id}`}
                    style={{
                      margin: '6px 4px',
                      borderRadius: 12,
                      background: 'rgba(220,38,38,0.06)',
                      border: '1px solid rgba(220,38,38,0.22)',
                      padding: '12px 16px',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, background: '#fee2e2', color: '#dc2626', padding: '2px 8px', borderRadius: 10, whiteSpace: 'nowrap' }}>1:1급여</span>
                        <span style={{ fontSize: 12, color: C.sub, whiteSpace: 'nowrap' }}>{item.date}</span>
                      </div>
                      <span style={{ fontSize: 15, fontWeight: 800, color: '#dc2626', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                        -{fmt(item.data.chargeAmount ?? item.data.charge_amount ?? 0)}원
                      </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginTop: 6 }}>
                      <div style={{ fontSize: 12, color: C.subDark, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {item.data.label || `${item.data.consultantName || item.data.consultant_name || '1:1 직원'} 급여`}
                      </div>
                      <button
                        type="button"
                        onClick={() => setChargeDetail(item.data)}
                        style={{ height: 32, minWidth: 82, border: '1px solid rgba(220,38,38,0.28)', borderRadius: 8, background: 'var(--bg-card)', color: '#dc2626', fontSize: 12, fontWeight: 900, cursor: 'pointer', whiteSpace: 'nowrap', padding: '0 14px' }}
                      >
                        계산내역
                      </button>
                    </div>
                  </div>
                ) : item.kind === 'others' ? (
                  // 기타 수입 카드 (앰버) — 음수는 +를 붙이지 않음
                  <div
                    key={`others-${item.data.id}`}
                    style={{
                      margin: '6px 4px', borderRadius: 12,
                      background: 'rgba(180,83,9,0.05)',
                      border: '1px solid rgba(180,83,9,0.2)',
                      padding: '12px 16px',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, background: '#fef3c7', color: '#b45309', padding: '2px 8px', borderRadius: 10 }}>기타</span>
                        <span style={{ fontSize: 12, color: C.sub }}>{item.data.date}</span>
                      </div>
                      <span style={{
                        fontSize: 15,
                        fontWeight: 800,
                        color: Number(item.data.amount) > 0 ? '#059669' : Number(item.data.amount) < 0 ? '#dc2626' : '#b45309',
                        fontVariantNumeric: 'tabular-nums',
                      }}>
                        {item.data.amount > 0 ? '+' : ''}{fmt(item.data.amount)}원
                      </span>
                    </div>
                    {item.data.description && (
                      <div style={{ marginTop: 6, fontSize: 12, color: C.subDark }}>{item.data.description}</div>
                    )}
                    {item.data.note && (
                      <div style={{ marginTop: 4, fontSize: 11, color: C.sub }}>{item.data.note}</div>
                    )}
                  </div>
                ) : (
                  // 정산지급 카드 — 정산서 합계에서는 지출(-)로 처리
                  <div
                    key={`settlement-${item.data.id}`}
                    style={{
                      margin: '6px 4px', borderRadius: 12,
                      background: 'rgba(220,38,38,0.06)',
                      border: '1px solid rgba(220,38,38,0.22)',
                      padding: '12px 16px',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 11, fontWeight: 700, background: '#fee2e2', color: '#dc2626', padding: '2px 8px', borderRadius: 10 }}>정산지급</span>
                        {item.data.pay_tax_type === 'business' && (
                          <span style={{ fontSize: 10, fontWeight: 800, background: 'rgba(37,99,235,0.12)', color: '#2563eb', padding: '1px 6px', borderRadius: 8 }}>사업자 +부가세</span>
                        )}
                        <span style={{ fontSize: 12, color: C.sub }}>{toDateString(item.data.settlement_date)}</span>
                      </div>
                      <span style={{ fontSize: 15, fontWeight: 800, color: '#dc2626', fontVariantNumeric: 'tabular-nums' }}>
                        -{fmt(Math.abs(Number(item.data.amount) || 0))}원
                        {item.data.pay_tax_type === 'business' && item.data.net_amount != null && (
                          <div style={{ fontSize: 11, fontWeight: 600, color: C.sub, textAlign: 'right' }}>실지급 {fmt(item.data.net_amount)}원</div>
                        )}
                      </span>
                    </div>
                    {item.data.note && (
                      <div style={{ marginTop: 6, fontSize: 12, color: C.subDark, borderTop: '1px solid rgba(13,148,136,0.2)', paddingTop: 6 }}>
                        {item.data.note}
                      </div>
                    )}
                  </div>
                )
              )}
            </>
          )}

          {/* ── 미연결 결제 탭 — settlementdot/PayGroup 직접 사용 ── */}
          {leftTab === 'unmatched' && (
            <>
              {unmTotal === 0 ? (
                <div style={emptyTxt}>미연결 결제 없음</div>
              ) : (
                <div style={{ padding: '8px 4px 0' }}>
                  {/* 안내 */}
                  <div style={{ padding: '4px 8px 8px', fontSize: 11, color: C.sub }}>
                    항목 클릭 후 [담당 매장] 탭에서 매장을 클릭하면 연결됩니다.
                  </div>

                  {/* 카드 업로드 */}
                  <PayGroup
                    title="카드업로드" type="card_upload"
                    items={unmatchedRevenue.cardUploads || []}
                    selectedPay={selectedPay}
                    onDragStart={() => {}}
                    onClick={handlePaymentClick}
                    getDate={(i) => i.transactionDate}
                    getLabel={(i) => i.cardIssuer || i.merchantName || '—'}
                    getSub={(i) => i.installment_months > 0 ? `${i.installment_months}개월` : '일시불'}
                    getAmt={(i) => i.amount}
                  />

                  {/* 카드승인 */}
                  <PayGroup
                    title="카드승인" type="card"
                    items={unmatchedRevenue.cards}
                    selectedPay={selectedPay}
                    onDragStart={() => {}}
                    onClick={handlePaymentClick}
                    getDate={(i) => i.transactionDate}
                    getLabel={(i) => i.cardIssuer || i.merchantName || '—'}
                    getSub={(i) => i.note || null}
                    getAmt={(i) => i.amount}
                  />

                  {/* 전화승인 */}
                  <PayGroup
                    title="전화승인" type="phone"
                    items={unmatchedRevenue.phones}
                    selectedPay={selectedPay}
                    onDragStart={() => {}}
                    onClick={handlePaymentClick}
                    getDate={(i) => i.paymentDate}
                    getLabel={(i) => i.cardCompany || '—'}
                    getSub={(i) => i.note || null}
                    getAmt={(i) => i.amount}
                  />

                  {/* 입금 */}
                  <PayGroup
                    title="입금" type="payments"
                    items={unmatchedRevenue.deposits}
                    selectedPay={selectedPay}
                    onDragStart={() => {}}
                    onClick={handlePaymentClick}
                    getDate={(i) => i.paymentDate}
                    getLabel={(i) => i.payerName || '—'}
                    getSub={(i) => i.note || null}
                    getAmt={(i) => i.amount}
                  />
                </div>
              )}
            </>
          )}

        </div>
      )}
      {chargeDetail && (
        <ConsultantChargeDetailModal
          charge={chargeDetail}
          summaryScope="admin"
          onClose={() => setChargeDetail(null)}
        />
      )}
    </div>
  );
}
